import { createRouter, createWebHistory } from "vue-router";
import RTL from "../views/Rtl.vue";
import Guard from '../services/middleware';
import DashboardLayout from "../../src/layout/DashboardLayout"
import Signin from "../views/Signin.vue";
import Dashboard from "../views/Painel/Dashboard.vue";
import Assinaturas from "../views/Painel/Assinaturas.vue";
import VisualizarAssinatura from "../views/Painel/VisualizarAssinatura.vue";
import CadastrarAssinatura from "../views/Painel/CadastrarAssinatura";
import Planos from "../views/Painel/Planos.vue";
import CadastrarPlano from "../views/Painel/CadastrarPlano.vue";
import Profissionais from "../views/Painel/Profissionais.vue";
import CadastrarProfissional from "../views/Painel/CadastrarProfissional.vue";
import AdicionarPlanoProfissional from "../views/Painel/AdicionarPlanoProfissional.vue";
import PlanoCorretor from "../views/Painel/PlanoCorretor.vue";
import Cursos from "../views/Painel/Cursos.vue";
import CadastrarCurso from "../views/Painel/CadastrarCurso.vue";
import Lojas from "../views/Painel/Lojas.vue";
import CadastrarLoja from "../views/Painel/CadastrarLoja.vue";
import Livros from "../views/Painel/Livros.vue";
import CadastrarLivro from "../views/Painel/CadastrarLivro.vue";
import Clinicas from "../views/Painel/Clinicas.vue";
import PagamentosClinicas from "../views/Painel/PagamentosClinicas.vue";
import CadastrarPagamento from "../views/Painel/CadastrarPagamento.vue";
import CadastrarClinica from "../views/Painel/CadastrarClinica.vue";
import AdicionarProfissionalClinica from "../views/Painel/AdicionarProfissionalClinica.vue";
import AdicionarRedeSocialClinica from "../views/Painel/AdicionarRedeSocialClinica.vue";
import AdicionarPlanoClinica from "../views/Painel/AdicionarPlanoClinica.vue";
import DepoimentoClinica from "../views/Painel/DepoimentoClinica.vue";
import PedidosCartao from "../views/Painel/PedidosCartao.vue";
import VisualizarPedido from "../views/Painel/VisualizarPedido.vue";
import Jogos from "../views/Painel/Jogos.vue";
import CadastrarJogo from "../views/Painel/CadastrarJogo.vue";
import Especialidades from "../views/Painel/Especialidades.vue";
import CadastrarEspecialidade from "../views/Painel/CadastrarEspecialidade.vue";
import Usuarios from "../views/Painel/Usuarios.vue";
import CadastrarUsusario from "../views/Painel/CadastrarUsusario.vue";
import CategoriasLoja from "../views/Painel/CategoriasLoja.vue";
import CadastrarCategoria from "../views/Painel/CadastrarCategoria.vue";
import CadastrarServico from "../views/Painel/CadastrarServico.vue";
import CadastrarMidiaSocial from "../views/Painel/CadastrarMidiaSocial.vue";
import CadastrarCliente from "../views/Painel/CadastrarCliente.vue";
import Empresa from "../views/Painel/Empresa.vue";
import Eventos from "../views/Painel/Eventos.vue";
import CadastrarEvento from "../views/Painel/CadastrarEvento.vue";
import Contatos from "../views/Painel/Contatos.vue";
import VisualizarContato from "../views/Painel/VisualizarContato.vue";
import ImgBlog from "../views/Painel/ImgBlog.vue";
import CadastrarImgBlog from "../views/Painel/CadastrarImgBlog.vue";
import RedesSociais from "../views/Painel/RedesSociais.vue";
import CadastrarRedeSocial from "../views/Painel/CadastrarRedeSocial.vue";
import Paginas from "../views/Painel/Paginas.vue";
import CadastrarPagina from "../views/Painel/CadastrarPagina.vue";
import Corretores from "../views/Painel/Corretores.vue";
import CadastrarCorretor from "../views/Painel/CadastrarCorretor.vue";
import TopicoPagina from "../views/Painel/TopicoPagina.vue";
import Valores from "../views/Painel/Valores.vue";
import CadastrarValor from "../views/Painel/CadastrarValor.vue";
import VisualizarPagamento from "../views/Painel/VisualizarPagamento.vue";
import GruposApoio from "../views/Painel/GruposApoio.vue";
import CadastrarGrupo from "../views/Painel/CadastrarGrupoApoio";
import Financeiro from "../views/Painel/Financeiro";
import AdicionarCartaoProfissional from "../views/Painel/AdicionarCartaoProfissional";
import AdicionarCartaoClinica from "../views/Painel/AdicionarCartaoClinica";
import AdicionarCartaoCorretor from "../views/Painel/AdicionarCartaoCorretor";

const routes = [

  {
    path: "/",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/",
    redirect: "",
    component: DashboardLayout,
    children: [

      {
        path: "/dashboard",
        name: "dashboard",
        components: { default: Dashboard },
        beforeEnter: Guard.auth
      },
      {
        path: "/assinaturas",
        name: "Assinaturas",
        components: { default: Assinaturas },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-assinatura",
        name: "CadastrarAssinatura",
        components: { default: CadastrarAssinatura },
        beforeEnter: Guard.auth
      },
      {
        path: "/visualizar-assinatura/:id",
        name: "VisualizarAssinatura",
        components: { default: VisualizarAssinatura },
        beforeEnter: Guard.auth
      },

      {
        path: "/profissionais",
        name: "Profissionais",
        components: { default: Profissionais },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-profissional",
        name: "CadastrarProfissional",
        components: { default: CadastrarProfissional },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-profissional/:id",
        name: "AlterarProfissional",
        components: { default: CadastrarProfissional },
        beforeEnter: Guard.auth
      },
      {
        path: "/adicionar-plano-profissional/:id",
        name: "AdicionarPlanoProfissional",
        components: { default: AdicionarPlanoProfissional },
        beforeEnter: Guard.auth
      },
      {
        path: "/adicionar-cartao-profissional/:id",
        name: "AdicionarCartaoProfissional",
        components: { default: AdicionarCartaoProfissional },
        beforeEnter: Guard.auth
      },

      {
        path: "/plano-corretor/:id",
        name: "PlanoCorretor",
        components: { default: PlanoCorretor },
        beforeEnter: Guard.auth
      },


      {
        path: "/planos-saude",
        name: "Planos",
        components: { default: Planos },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-plano-saude",
        name: "CadastrarPlano",
        components: { default: CadastrarPlano },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-plano-saude/:id",
        name: "AlterarPlano",
        components: { default: CadastrarPlano },
        beforeEnter: Guard.auth
      },


      {
        path: "/cursos",
        name: "Cursos",
        components: { default: Cursos },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-curso",
        name: "CadastrarCurso",
        components: { default: CadastrarCurso },
        beforeEnter: Guard.auth
      },
      {
        path: "/alterar-curso/:id",
        name: "AlterarCurso",
        components: { default: CadastrarCurso },
        beforeEnter: Guard.auth
      },

      {
        path: "/lojas",
        name: "Lojas",
        components: { default: Lojas },
        beforeEnter: Guard.auth
      },
      {
        path: "/eventos",
        name: "Eventos",
        components: { default: Eventos },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-evento",
        name: "CadastrarEvento",
        components: { default: CadastrarEvento },
        beforeEnter: Guard.auth
      },
      {
        path: "/alterar-evento/:id",
        name: "AlterarEvento",
        components: { default: CadastrarEvento },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-loja",
        name: "CadastrarLoja",
        components: { default: CadastrarLoja },
        beforeEnter: Guard.auth
      },
      {
        path: "/alterar-loja/:id",
        name: "AlterarLoja",
        components: { default: CadastrarLoja },
        beforeEnter: Guard.auth
      },
      {
        path: "/livros",
        name: "Livros",
        components: { default: Livros },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-livro",
        name: "CadastrarLivro",
        components: { default: CadastrarLivro },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-livro/:id",
        name: "AlterarLivro",
        components: { default: CadastrarLivro },
        beforeEnter: Guard.auth
      },

      {
        path: "/clinicas",
        name: "Clinicas",
        components: { default: Clinicas },
        beforeEnter: Guard.auth
      },
      {
        path: "/adicionar-cartao-clinica/:id",
        name: "AdicionarCartaoClinica",
        components: { default: AdicionarCartaoClinica },
        beforeEnter: Guard.auth
      },

      {
        path: "/valores",
        name: "Valores",
        components: { default: Valores },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-valor",
        name: "CadastrarValor",
        components: { default: CadastrarValor },
        beforeEnter: Guard.auth
      },
      {
        path: "/alterar-valor/:id",
        name: "AlterarValor",
        components: { default: CadastrarValor },
        beforeEnter: Guard.auth
      },

      {
        path: "/pagamentos",
        name: "Pagamentos",
        components: { default: PagamentosClinicas },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-pagamento",
        name: "CadastrarPagamento",
        components: { default: CadastrarPagamento },
        beforeEnter: Guard.auth
      },
      {
        path: "/visualizar-pagamento/:id",
        name: "VisualizarPagamento",
        components: { default: VisualizarPagamento },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-clinica",
        name: "CadastrarClinica",
        components: { default: CadastrarClinica },
        beforeEnter: Guard.auth
      },

      {
        path: "/depoimento-clinica/:id",
        name: "DepoimentoClinica",
        components: { default: DepoimentoClinica },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-clinica/:id",
        name: "AlterarClinica",
        components: { default: CadastrarClinica },
        beforeEnter: Guard.auth
      },
      {
        path: "/adicionar-profissional-clinica/:id",
        name: "AdicionarProfissionalClinica",
        components: { default: AdicionarProfissionalClinica },
        beforeEnter: Guard.auth
      },
      {
        path: "/adicionar-rede-social-clinica/:id",
        name: "AdicionarRedeSocialClinica",
        components: { default: AdicionarRedeSocialClinica },
        beforeEnter: Guard.auth
      },
      {
        path: "/adicionar-plano-clinica/:id",
        name: "AdicionarPlanoClinica",
        components: { default: AdicionarPlanoClinica },
        beforeEnter: Guard.auth
      },

      {
        path: "/pedidos-cartao",
        name: "PedidosCartao",
        components: { default: PedidosCartao },
        beforeEnter: Guard.auth
      },
      {
        path: "/visualizar-pedido-cartao/:id",
        name: "VisualizarPedido",
        components: { default: VisualizarPedido },
        beforeEnter: Guard.auth
      },

      {
        path: "/especialidades",
        name: "Especialidades",
        components: { default: Especialidades },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-especialidade",
        name: "CadastrarEspecialidade",
        components: { default: CadastrarEspecialidade },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-especialidade/:id",
        name: "AlterarEspecialidade",
        components: { default: CadastrarEspecialidade },
        beforeEnter: Guard.auth
      },

      {
        path: "/jogos",
        name: "Jogos",
        components: { default: Jogos },
        beforeEnter: Guard.auth
      },

      {
        path: "/financeiro",
        name: "Financeiro",
        components: { default: Financeiro },
        beforeEnter: Guard.auth
      },

      {
        path: "/grupos-apoio",
        name: "GruposApoio",
        components: { default: GruposApoio },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-grupo",
        name: "CadastrarGrupo",
        components: { default: CadastrarGrupo },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-grupo/:id",
        name: "AlterarGrupo",
        components: { default: CadastrarGrupo },
        beforeEnter: Guard.auth
      },

      {
        path: "/corretores",
        name: "Corretores",
        components: { default: Corretores },
        beforeEnter: Guard.auth
      },

      {
        path: "/cadastrar-corretor",
        name: "CadastrarCorretor",
        components: { default: CadastrarCorretor },
        beforeEnter: Guard.auth
      },
      {
        path: "/alterar-corretor/:id",
        name: "AlterarCorretor",
        components: { default: CadastrarCorretor },
        beforeEnter: Guard.auth
      },
      {
        path: "/adicionar-cartao-corretor/:id",
        name: "AdicionarCartaoCorretor",
        components: { default: AdicionarCartaoCorretor },
        beforeEnter: Guard.auth
      },


      {
        path: "/cadastrar-jogo",
        name: "CadastrarJogo",
        components: { default: CadastrarJogo },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-jogo/:id",
        name: "AlterarJogo",
        components: { default: CadastrarJogo },
        beforeEnter: Guard.auth
      },

      {
        path: "/admin/rtl-page",
        name: "RTL",
        components: { default: RTL },
        beforeEnter: Guard.auth
      },
      {
        path: "/usuarios",
        name: "Usuarios",
        components: { default: Usuarios },
        beforeEnter: Guard.auth
      },
      {
        path: "/alterar-usuario/:id",
        name: "AlterarUsusario",
        components: { default: CadastrarUsusario },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-usuario",
        name: "CadastrarUsuario",
        components: { default: CadastrarUsusario },
        beforeEnter: Guard.auth
      },
      {
        path: "/categorias-loja",
        name: "CategoriasLoja",
        components: { default: CategoriasLoja },
        beforeEnter: Guard.auth
      },

      {
        path: "/alterar-categoria/:id",
        name: "AlterarCategoria",
        components: { default: CadastrarCategoria },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-categoria",
        name: "CadastrarCategoria",
        components: { default: CadastrarCategoria },
        beforeEnter: Guard.auth
      },

      {
        path: "/admin/cadastrar-servico",
        name: "CadastrarServico",
        components: { default: CadastrarServico },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/alterar-servico",
        name: "AlterarServico",
        components: { default: CadastrarServico },
        beforeEnter: Guard.auth
      },

      {
        path: "/admin/cadastrar-midia-social",
        name: "CadastrarMidiaSocial",
        components: { default: CadastrarMidiaSocial },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/alterar-midia-social/:id",
        name: "AlterarMidia",
        components: { default: CadastrarMidiaSocial },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/cadastrar-cliente",
        name: "CadastrarCliente",
        components: { default: CadastrarCliente },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/alterar-cliente/:id",
        name: "AlterarCliente",
        components: { default: CadastrarCliente },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/empresa",
        name: "Empresa",
        components: { default: Empresa },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/contatos",
        name: "Contatos",
        components: { default: Contatos },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/visualzar-contato/:id",
        name: "VisualizarContato",
        components: { default: VisualizarContato },
        beforeEnter: Guard.auth
      },

      {
        path: "/admin/img-blog",
        name: "ImagensBlog",
        components: { default: ImgBlog },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/cadastrar-img-blog",
        name: "CadastrarImgBlog",
        components: { default: CadastrarImgBlog },
        beforeEnter: Guard.auth
      },
      {
        path: "/admin/alterar-img-blog/:id",
        name: "AlterarImg",
        components: { default: CadastrarImgBlog },
        beforeEnter: Guard.auth
      },
      {
        path: "/profissionais",
        name: "Profissionais",
        components: { default: Profissionais },
        beforeEnter: Guard.auth
      },
      {
        path: "/redes-sociais",
        name: "RedesSociais",
        components: { default: RedesSociais },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-rede-social",
        name: "CadastrarRedeSocial",
        components: { default: CadastrarRedeSocial },
        beforeEnter: Guard.auth
      },
      {
        path: "/alterar-rede-social/:id",
        name: "AlterarRede",
        components: { default: CadastrarRedeSocial },
        beforeEnter: Guard.auth
      },
      {
        path: "/paginas",
        name: "Paginas",
        components: { default: Paginas },
        beforeEnter: Guard.auth
      },
      {
        path: "/cadastrar-pagina",
        name: "CadastrarPaginas",
        components: { default: CadastrarPagina },
        beforeEnter: Guard.auth
      },
      {
        path: "/visualizar-pagina/:id",
        name: "visualizarPagina",
        components: { default: CadastrarPagina },
        beforeEnter: Guard.auth
      },
      {
        path: "/topico-pagina/:id",
        name: "TopicoPagina",
        components: { default: TopicoPagina },
        beforeEnter: Guard.auth
      },
    ]
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
